import { useState, useEffect, useReducer } from "react";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { getTransactionTable } from "../graphql/queries";
import { generateClient } from 'aws-amplify/api';

const client = generateClient();

const Transaction = () => {
  const navigate = useNavigate();
  let id = useParams()?.id;
  const [transactionInfo, setTransactionInfo] = useState({
    SerialNumber: "",
    CustomerName: "",
    Barcode: "",
    Error: "",
    InsertTime: "",
    Length: "",
    Width: "",
    Height: "",
    Weight: "",
    Shape: "",
    Note: "",
    Attributes: ""
  })

  useEffect(() => {
    async function fetchData() {
      if (id && id.length > 0) {
        const txDetails = {
          id: id,
        };
        const result = await client.graphql({
          query: getTransactionTable,
          variables: txDetails
        });
        if (result) {
          var dataIn = JSON.parse(result.data.getTransactionTable.Data);
          const dbData = {
            SerialNumber: result.data.getTransactionTable.SerialNumber,
            CustomerName: result.data.getTransactionTable.CustomerName,
            Barcode: result.data.getTransactionTable.Barcode,
            Error: result.data.getTransactionTable.Error,
            InsertTime: result.data.getTransactionTable.InsertTime,
            Length: dataIn.Length,
            Width: dataIn.Width,
            Height: dataIn.Height,
            Weight: dataIn.CapturedWeight,
            Shape: dataIn.Shape,
            Note: dataIn.Note,
            Attributes: JSON.stringify(dataIn.Attributes)
          };
          setTransactionInfo(dbData);
        }
      }
    }
    fetchData();
  }, [id]);

  return (
    <form className="ui form">
      <div className="equal width fields">
        <div className="field">
          <label htmlFor="serialNumber">Serial Number</label>
          <label>{transactionInfo.SerialNumber}</label>
        </div>
        <div className="field">
          <label htmlFor="customerName">Customer Name</label>
          <label>{transactionInfo.CustomerName}</label>
        </div>
        <div className="field">
          <label htmlFor="barcode">Barcode</label>
          <label>{transactionInfo.Barcode}</label>
        </div>
        <div className="field">
          <label htmlFor="insertTime">Insert Time</label>
          <label>{transactionInfo.InsertTime}</label>
        </div>
      </div>
      <div className="equal width fields">
        <div className="field">
          <label htmlFor="length">Length</label>
          <label>{transactionInfo.Length}</label>
        </div>
        <div className="field">
          <label htmlFor="width">Width</label>
          <label>{transactionInfo.Width}</label>
        </div>
        <div className="field">
          <label htmlFor="height">Height</label>
          <label>{transactionInfo.Height}</label>
        </div>
        <div className="field">
          <label htmlFor="Weight">Weight</label>
          <label>{transactionInfo.Weight}</label>
        </div>
      </div>
      <div className="equal width fields">
        <div className="field">
          <label htmlFor="shape">Shape</label>
          <label>{transactionInfo.Shape}</label>
        </div>
        <div className="field">
          <label htmlFor="note">Note</label>
          <label>{transactionInfo.Note}</label>
        </div>
      </div>
      <div className="equal width fields">
        <div className="field">
          <label htmlFor="error">Status</label>
          <label>{transactionInfo.Error}</label>
        </div>
        <div className="field">
          <label htmlFor="attributes">Attributes</label>
          <label>{transactionInfo.Attributes}</label>
        </div>
      </div>
    </form>
  )
}

export default Transaction;